<template>
    <div v-if="!hide" class="form-network form-network-google" >

        <details open>
            <summary>Aperçu du lien <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
                  
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataGoogle.snippet.link == url)" 
                            :isDisable="(formDataGoogle.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
              
            </div>
        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from './../../../../store/index.js';
   import ComponentSwitch from '../../utils/switch.vue'
   import SelectComponent from '../../utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '../../../mixins/Bots.vue'
   import minxinPost from '../../../mixins/Posts.vue'
   import Checkbox from '../../utils/checkbox.vue'
   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           formData: {
               type: Object,
               default: () => ({})
           },

           formDataGoogle: {
               type: Object,
               default: () => ({})
           },
       },

       data() {
           return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
           }
       },

       
       mounted() {
            if (this.formData.formDataNetwork.google) this.formDataGoogle = this.formData.formDataNetwork.google
       },

       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectTypeContent(typeContent = '') {
                this.formDataGoogle.typeContent = this.formDataGoogle.typeContent == typeContent ? '' : typeContent
                this.$emit('setFormDataNetwork', 'google', this.formDataGoogle)
            },

            detectTypeContent() {
                if(this.formData.files.length) { 
                    if(this.formDataGoogle.typeContent !== 'survey' 
                        && (this.formDataGoogle.typeContent !== 'link' || !this.formDataGoogle.snippet.link)
                        && !this.formData.files.find(file => file.type2 == this.formDataGoogle.typeContent)) {

                        let file = this.formData.files.find(file => ['video','image','pdf'].includes(file.type2))
                        if (file) {
                            this.formDataGoogle.typeContent = file.type2
                            this.$emit('setFormDataNetwork', 'google', this.formDataGoogle)
                        }
                    }
                }
            },

    
            selectUrl(url) {
                if (!this.formDataGoogle.snippet) this.formDataGoogle.snippet = {}
                this.formDataGoogle.snippet.link = this.formDataGoogle.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'google', this.formDataGoogle)
            },


            verifUrlSelected() {
                if (this.formData.urlsTextContentHistory.size) {
                    let linkSelect = this.formDataGoogle && this.formDataGoogle.snippet && this.formDataGoogle.snippet.link ? this.formDataGoogle.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.has(linkSelect)) || !linkSelect) {
                        this.selectUrl(this.formData.urlsTextContentHistory.values().next().value)
                    }
                }else{
                    this.selectUrl('')
                }
            },
       },

       computed: {
           allPages() {
               return this.$store.getters['selectPage/selectPageAllPages'];
           },
           pagesSelected() {
               return this.$store.getters['selectPage/selectPagePageSelected'];
           },
       },

       watch: {
            ['formData.formDataNetwork.google']() {
                if (this.formData.formDataNetwork.google) this.formDataGoogle = this.formData.formDataNetwork.google
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            'formData.files'(newValue) {
                this.detectTypeContent()
            }
       },


       beforeDestroy () {
         
       }
       
   }
</script>